import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {NgbAccordion} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ds-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss']
})
export class AccordionItemComponent {
  @ViewChild('acc', {static: true}) accordion: NgbAccordion;
  @ViewChild('panelToggle') panelToggle: ElementRef;
  @Input() accordionId: string;
  @Input() header: string;
  small: boolean;
  indented: boolean;
  borderColor: string;
}
